enum SkeletonShapeEnum {
    'Rectangle' = 'rectangle',
    'Circle' = 'circle',
}

export default SkeletonShapeEnum;
